import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { EventType } from 'src/app/utils/interfaces/new/event-type.interface';
import { Event } from 'src/app/utils/interfaces/old/agenda-interface';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { EventRecurrence } from 'src/app/utils/interfaces/new/event-recurrence.interface';
import { EventRecurrenceComponent } from '../event-recurrence/event-recurrence.component';
import { NgxMaterialTimepickerTheme, NgxTimepickerFieldComponent } from 'ngx-material-timepicker';
import { EventResource, SuperTypeEnum } from 'src/app/utils/interfaces/new/event-resource.interface';
import { RessourceCreationRendezVous } from 'src/app/utils/interfaces/new/RessourceCreationRendezVous';
import { PatientService } from 'src/app/services/patient/patient.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { CreationPatient } from 'src/app/utils/interfaces/new/creation-patient.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { EventConflictComponent } from '../event-conflict/event-conflict.component';
import { CreationRendezVous } from 'src/app/utils/interfaces/new/CreationRendezVous';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { EventReminder } from 'src/app/utils/interfaces/new/event-reminder';
import { LoginService } from 'src/app/services/login/login.service';
import { REGEX_NAME, StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { Adresse } from 'src/app/utils/interfaces/new/adresse.interface';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';

interface PatientConsultationTableDisplay {
  date: Date;
  heure: string;
  status: string;
  type: string;
}

interface InitialPatientInfos {
  phone: string;
  adress: string;
  zip: string;
  city: string;
  mail: string;
}

@Component({
  selector: 'app-event-create',
  templateUrl: './event-create.component.html',
  styleUrls: ['./event-create.component.scss']
})
export class EventCreateComponent implements OnInit, OnDestroy {

  @ViewChild('timepickerHourStart') public timepickerHourStart: NgxTimepickerFieldComponent;
  @ViewChild('timepickerHourEnd') public timepickerHourEnd: NgxTimepickerFieldComponent;
  private _timepickerHourStartSub: Subscription;
  private _timepickerHourEndSub: Subscription;
  private _initialDiff: number;

  public dateMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  public accountName = 'Docteur Renaud';
  public textAreaPlaceholder = 'Rédigez ici la description de ce rendez-vous';
  public formGroup: FormGroup;
  public patientFormGroup: FormGroup;
  public createPatientFormGroup: FormGroup;
  public resources: Array<EventResource> = [];
  public profilResources: Array<string> = [];
  public eventTypes: Array<EventType> = [];
  public hourSplitLabel: Array<string> = [];
  public displayContactInfos = true;
  public dayStartHour = '00:00';
  public dayEndHour = '23:00';

  public inputSearchForm: FormGroup;
  public searchingMessage = false;
  public isSearching = false;
  public editPatient = false;
  private initialPatientInfos: InitialPatientInfos;

  public isDateTimeHighlighted = false;

  public patientSearchList: Array<ResultatPatient> = [];
  public patientBirthMax = moment().format("YYYY-MM-DD");
  public patientBirthinx = moment((moment().year() - 150) + "-" + moment().month() + "-" + moment().day()).format("YYYY-MM-DD");

  public patientEvents: Paginated<PatientConsultationTableDisplay>;
  public patientEventsColumnTable = [
    { title: 'Date', data: 'date' },
    { title: 'Heure', data: 'heure' },
    { title: 'Statut', data: 'status' },
    { title: 'Type', data: 'type' }
  ];

  private doForce = false;

  public initialEvent: Event | null = null;
  private formHasChanged = false;
  private patientFormHasChanged = false;
  private eventRecurrence: EventRecurrence | null = null;

  private formChangeSubscribeValue: Subscription;
  private formChangeSubscribeLoading: Subscription;
  private formChangeSubscribe: Subscription;
  private patientFormChangeSubscribe: Subscription;
  private patientHourformChangeSubscribe: Subscription;
  private patientMinuteformChangeSubscribe: Subscription;
  private practitionerHourformChangeSubscribe: Subscription;
  private practitionerMinuteformChangeSubscribe: Subscription;

  public customTimePickerTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: 'var(--white)',
    },
    dial: {
      dialBackgroundColor: 'var(--primary)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--box-shadow-grey)',
      clockHandColor: 'var(--primary)',
      clockFaceTimeInactiveColor: 'var(--white)'
    }
  };

  // TODO Ces listes de label devraient disparaître lorsque le fragment form-input acceptera plus seulement des tableaux de string en paramètre
  public resourcesLabel: Array<string> = [];
  public eventTypesLabel: Array<string> = [];

  public readOnly = false;

  constructor(
    private formBuilder: FormBuilder,
    private agendaSrv: AgendaService,
    private modalSrv: ModalService,
    private viewContainerRef: ViewContainerRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private patientSrv: PatientService,
    private _send: HeaderCommunicationService,
    private resourceSrv: RessourceService,
    private loginSrv: LoginService,
    private _strUtilsSrv: StringUtilsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _snackbarSrv: SnackbarService
  ) {
    const dayStartHour = this.activatedRoute.snapshot.queryParamMap.get('dayStartHour');
    if (dayStartHour) {
      this.dayStartHour = dayStartHour;
    }

    const dayEndHour = this.activatedRoute.snapshot.queryParamMap.get('dayEndHour');
    if (dayEndHour) {
      this.dayEndHour = dayEndHour;
    }
  }

  ngOnInit(): void {
    this.initData();
  }

  ngAfterViewInit() {
    this.inputSearchForm = this.formBuilder.group({
      searchInput: ['']
    });

    this.formChangeSubscribeValue = this.inputSearchForm.valueChanges.pipe(debounceTime(500)).subscribe(async (event) => {
      await this.doSearchPatient(event.searchInput);
    });

    this.formChangeSubscribeLoading = this.inputSearchForm.valueChanges.subscribe(async (event) => {
      if (event.searchInput === '') {
        this.isSearching = false;
      } else {
        this.isSearching = true;
      }
    });

    this._initTimepickerChangeSub();
  }

  /**
   * Précisions :
   * Le composant 'ngx-timepicker-field' (composant externe) utilisé pour le time picker
   * ne permet pas de combiner une heure min et/ou max et une saisie au clavier.
   * Pour contourner cette limitation, nous avons supprimé
   * l'utilisation les attributs min et max (ce qui permet désormais une saisie au clavier)
   * Afin de d'empêcher la saisie d'une heure inférieure à l'heure d'ouverture
   * ou supérieure à l'heure de fermeture,
   * la méthode timeChanged() vérifie et manipule si besoin les données rentrées.
   * Mais le comportement du composant 'ngx-timepicker-field',
   * qui trigger à chaque frappe de clavier,
   * nous oblige à empêcher l'appel à la méthode timeChanged() lorsque l'utilisateur
   * rentre une heure avec le clavier, pour ensuite l'appeler lors de la perte de focus du champs.
   * C'est le but du mécanisme mis en place ici
   * où on s'abonne à l'évennement onkeypress des champs de saisie
   * pour éviter que la méthode timeChanged() ne modifie le champ.
   * Dans le détails :
   * - lors d'une saisie clavier on passe le booléen _nextEvtIsKeypress à true
   * - on appel la méthode timeChanged()
   * - celle-ci vérifie la valeur de la variable _nextEvtIsKeypress
   *     - si elle est à true, on la passe à false et on return tout de suite pour éviter le déroulement de la suite de la fonction
   *     - si elle est à false, on déroule normalement le code la fonction
   */
  private _nextEvtIsKeypress = false;
  private _handleTimeKeypress(evt: KeyboardEvent): void {
    this._nextEvtIsKeypress = true;
  }
  private _initTimepickerChangeSub(): void {
    if (!this._timepickerHourStartSub && this.timepickerHourStart) {
      this._timepickerHourStartSub = this.timepickerHourStart.timeChanged.pipe(debounceTime(0)).subscribe(v => {
        this.timeChanged(this.formGroup.get('hourStart'), this.timepickerHourStart);
      });

      const inputHour = document.querySelector('#timepickerHourStart .ngx-timepicker ngx-timepicker-time-control.ngx-timepicker__control--first .ngx-timepicker-control input');
      (inputHour as any).onkeypress = (v) => {
        this._handleTimeKeypress(v);
      };
      const inputMinute = document.querySelector('#timepickerHourStart .ngx-timepicker ngx-timepicker-time-control.ngx-timepicker__control--third .ngx-timepicker-control input');
      (inputMinute as any).onkeypress = (v) => {
        this._handleTimeKeypress(v);
      };
    }

    if (!this._timepickerHourEndSub && this.timepickerHourEnd) {
      this._timepickerHourEndSub = this.timepickerHourEnd.timeChanged.pipe(debounceTime(0)).subscribe(v => {
        this.timeChanged(this.formGroup.get('hourEnd'), this.timepickerHourEnd);
      });

      const inputHour = document.querySelector('#timepickerHourEnd .ngx-timepicker ngx-timepicker-time-control.ngx-timepicker__control--first .ngx-timepicker-control input');
      (inputHour as any).onkeypress = (v) => {
        this._handleTimeKeypress(v);
      };
      const inputMinute = document.querySelector('#timepickerHourEnd .ngx-timepicker ngx-timepicker-time-control.ngx-timepicker__control--third .ngx-timepicker-control input');
      (inputMinute as any).onkeypress = (v) => {
        this._handleTimeKeypress(v);
      };
    }

    if (!this._timepickerHourStartSub || !this._timepickerHourEndSub) {
      setTimeout(() => {
        this._initTimepickerChangeSub();
      }, 10);
    }
  }

  ngOnDestroy() {
    if (this.formChangeSubscribeValue) {
      this.formChangeSubscribeValue.unsubscribe();
    }

    if (this.formChangeSubscribeLoading) {
      this.formChangeSubscribeLoading.unsubscribe();
    }

    if (this.formChangeSubscribe) {
      this.formChangeSubscribe.unsubscribe();
    }

    if (this.patientFormChangeSubscribe) {
      this.patientFormChangeSubscribe.unsubscribe();
    }

    if (this.patientHourformChangeSubscribe) {
      this.patientHourformChangeSubscribe.unsubscribe();
    }

    if (this.patientMinuteformChangeSubscribe) {
      this.patientMinuteformChangeSubscribe.unsubscribe();
    }

    if (this.practitionerHourformChangeSubscribe) {
      this.practitionerHourformChangeSubscribe.unsubscribe();
    }

    if (this.practitionerMinuteformChangeSubscribe) {
      this.practitionerMinuteformChangeSubscribe.unsubscribe();
    }

    if (this._timepickerHourStartSub) {
      this._timepickerHourStartSub.unsubscribe();
    }

    if (this._timepickerHourEndSub) {
      this._timepickerHourEndSub.unsubscribe();
    }

    this.agendaSrv.doRemoveNavigationParams();

  }

  private async initData(): Promise<void> {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      if (this.activatedRoute.snapshot.queryParamMap.get('highlight')) {
        this.isDateTimeHighlighted = true;
      }

      this.resources = await this.getResources();
      this.eventTypes = await this.getEventTypes();
      this.hourSplitLabel = await this.getEventHourSplits();
      const eventResources: Array<string> = [];

      // TODO A RETIRER / Ces itération sauvages devraient disparaître lorsque le fragment form-input acceptera plus seulement des tableaux de string en paramètre
      for (const r of this.resources) {
        this.resourcesLabel.push(r.nom);
      }

      for (const r of this.eventTypes) {
        this.eventTypesLabel.push(r.label);
      }
      // A RETIRER FIN

      const eventId = this.activatedRoute.snapshot.paramMap.get('eventId');
      if (eventId) {
        this.initialEvent = await this.agendaSrv.getEventById(eventId);
        const currentProfil = this.loginSrv.getCurrentProfil();
        // nous n'avons plus acces au ressources non autoriser donc si on peut voir l'event on autorise.
        // if (!currentProfil || this.initialEvent.createdBy.id !== currentProfil.id) {
        if (!currentProfil){
          this.readOnly = true;
        }
        if (this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.dateNaissance) {
          this.initialEvent.patient.dateNaissance = moment(this.initialEvent.patient.dateNaissance, "YYYY-MM-DD").format("DD-MM-YYYY");
        }

        if (this.initialEvent && this.initialEvent.patient) {
          const tmpEvents = await this.agendaSrv.searchEvents(1, this.initialEvent.patient.id);
          await this.setPatientEvents(tmpEvents);
        }

        this.eventRecurrence = this.initialEvent.recurrence;

        for (const r of this.initialEvent.ressourses) {
          eventResources.push(r.nom);
        }
      }

      if (this.activatedRoute.snapshot.queryParamMap.get('doDuplicate')) {
        this.initialEvent.id = '';
        // this.initialEvent.patient = undefined;
        if (this.initialEvent.recurrence) {
          this.initialEvent.recurrence = undefined;
          this.eventRecurrence = this.initialEvent.recurrence;
        }
      }

      let reminds: EventReminder;

      let defaultEventType = this.eventTypes.find(t => t.typeParDefaut === true);

      if (!this.initialEvent && defaultEventType) {
        for (const r of defaultEventType.ressources) {
          eventResources.push(r.nom);
        }
      }

      const resourceId = this.activatedRoute.snapshot.queryParamMap.get('resourceId');
      const resourceType = this.activatedRoute.snapshot.queryParamMap.get('resourceType');
      const resourceName = this.activatedRoute.snapshot.queryParamMap.get('resourceName');

      if (resourceId && resourceType && resourceName) {
        if (eventResources.length === 0) {
          eventResources.push(resourceName);
        }
        reminds = await this.resourceSrv.getRemindParameters(resourceId, resourceType);
      } else {
        const currentProfilStr = localStorage.getItem('currentProfil');
        const currentUserStr = localStorage.getItem('currentUser');
        if (currentProfilStr && currentProfilStr !== '' && currentUserStr && currentUserStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          const currentUser = JSON.parse(currentUserStr);
          if (currentProfil && currentProfil.id
            && currentUser.nom && currentUser.nom !== ''
            && currentUser.prenom && currentUser.prenom !== ''
            && this.resourcesLabel.find(r => r === currentProfil.qualite ? `${currentProfil.qualite} ${currentUser.nom} ${currentUser.prenom}` : `${currentUser.nom} ${currentUser.prenom}`)
            && !eventResources.find(r => r === currentProfil.qualite ? `${currentProfil.qualite} ${currentUser.nom} ${currentUser.prenom}` : `${currentUser.nom} ${currentUser.prenom}`)) {
            eventResources.push(currentProfil.qualite ? `${currentProfil.qualite} ${this._strUtilsSrv.uppercaseFirstCharString(currentUser.prenom)} ${currentUser.nom}` : `${this._strUtilsSrv.uppercaseFirstCharString(currentUser.prenom)} ${currentUser.nom}`);

            reminds = await this.resourceSrv.getRemindParameters(currentProfil.id, 'profil');
          }
        }
      }

      let recurrenceLabel = this.setRecurrenceLabel(this.initialEvent ? this.initialEvent.recurrence : null);

      if (this.initialEvent && this.initialEvent.rappel) {
        reminds = this.initialEvent.rappel;
      }

      const slotStart = this.activatedRoute.snapshot.queryParamMap.get('slotStart');
      const slotEnd = this.activatedRoute.snapshot.queryParamMap.get('slotEnd');
      const eventTypeId = this.activatedRoute.snapshot.queryParamMap.get('eventTypeId');
      const forceSlot = this.activatedRoute.snapshot.queryParamMap.get('forceSlot');
      const doForce = this.activatedRoute.snapshot.queryParamMap.get('doForce');
      if (doForce && doForce === 'true') {
        this.doForce = true;
      }

      if (eventTypeId) {
        defaultEventType = this.eventTypes.find(t => t.id === eventTypeId);
      }

      let hourStart = moment().format('HH:mm');
      let hourEnd = moment().format('HH:mm');

      if (this.initialEvent && this.initialEvent.type) {
        defaultEventType = this.initialEvent.type;
      }

      if (this.initialEvent && this.initialEvent.dateDebut && this.initialEvent.dateFin) {
        hourStart = moment(this.initialEvent.dateDebut).format('HH:mm');
        hourEnd = moment(this.initialEvent.dateFin).format('HH:mm');
      } else if (forceSlot && slotStart && slotEnd) {
        hourStart = moment(slotStart).format('HH:mm');
        hourEnd = moment(slotEnd).format('HH:mm');
      } else if (defaultEventType) {
        hourStart = moment(slotStart ? slotStart : undefined).format('HH:mm');
        hourEnd = moment(slotStart ? slotStart : undefined).add(defaultEventType.duree.split(':')[0], 'hour').add(defaultEventType.duree.split(':')[1], 'minute').format('HH:mm');
      } else if (slotStart && slotEnd) {
        hourStart = moment(slotStart).format('HH:mm');
        hourEnd = moment(slotEnd).format('HH:mm');
      }

      let toPlan = false;
      if (this.initialEvent && !this.initialEvent.planifie) {
        toPlan = true;
      } else if (slotStart && slotEnd) {
        toPlan = true;
      }

      let dateStart = '';
      let dateEnd = '';
      if (this.initialEvent && this.initialEvent.dateDebut && this.initialEvent.dateFin) {
        dateStart = moment(this.initialEvent.dateDebut).format('yyyy-MM-DD');
        dateEnd = moment(this.initialEvent.dateFin).format('yyyy-MM-DD');
      } else if (slotStart && slotEnd) {
        dateStart = moment(slotStart).format('yyyy-MM-DD');
        dateEnd = moment(slotEnd).format('yyyy-MM-DD');
      } else {
        dateStart = moment().format('yyyy-MM-DD');
        dateEnd = moment().format('yyyy-MM-DD');
      }
      let texteDupliquer = '';
      if(this.activatedRoute.snapshot.queryParamMap.get('doDuplicate')){
        let DateDuplique = moment(this.initialEvent.dateDebut).format('DD/MM/yyyy');
        texteDupliquer = `\n-RDV dupliquer du ${DateDuplique} à ${hourStart}`
      }
      if(this.activatedRoute.snapshot.queryParamMap.get('highlight')){
        let DateInitiale = moment(this.initialEvent.dateDebut).format('DD/MM/yyyy');
        texteDupliquer = `\n-RDV reporter du ${DateInitiale} à ${hourStart}`
      }

      this.formGroup = this.formBuilder.group({
        toPlan: [toPlan],
        type: [defaultEventType?.label || ''],
        dateStart: [dateStart],
        dateEnd: [dateEnd],
        hourStart: [hourStart],
        hourEnd: [hourEnd],
        resource: [eventResources],
        recurrence: [recurrenceLabel],
        hourSplit: ['0 minutes'],
        reminder: [reminds.rappeler ? true : false],
        reminderSMS: [reminds.rappelSMS ? true : false],
        reminderMail: [reminds.rappelMail ? true : false],
        reminderConfirmation: [reminds.confirmationMeeting ? true : false],
        patientReminderDays: [reminds.rappelPatientJours ? reminds.rappelPatientJours : 0],
        patientReminderMinutes: [reminds.rappelPatientMinutes ? reminds.rappelPatientMinutes : 0],
        practitionerReminderDays: [reminds.rappelPraticienJours ? reminds.rappelPraticienJours : 0],
        practitionerReminderMinutes: [reminds.rappelPraticienMinutes ? reminds.rappelPraticienMinutes : 0],
        description: [this.initialEvent && this.initialEvent.description ? this.initialEvent.description + texteDupliquer: '']
      });
      this._setInitialdiff();

      if (this.initialEvent && this.initialEvent.patient) {
        this.patientFormGroup = this.formBuilder.group({
          nom: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.nom],
          prenom: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.prenom],
          dateNaissance: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.dateNaissance],
          patientAddress: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.adresse ? this.initialEvent.patient.adresse : ''],
          patientZip: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.codePostal ? this.initialEvent.patient.codePostal : ''],
          patientCity: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.ville ? this.initialEvent.patient.ville : ''],
          patientPhone: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.telephone ? this.initialEvent.patient.telephone : '', [Validators.pattern(/^[0-9]{10}$/)]],
          patientMail: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.email ? this.initialEvent.patient.email : '', [Validators.email, Validators.pattern(/[aA-zZ]+[.][aA-zZ]{2,}/)]],
          patientAddressId: [this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.adresseId ? this.initialEvent.patient.adresseId : '']
        });
        this.handlePatientFormChange();
      }

      if (slotStart && slotEnd) {
        this.formGroup.get('toPlan').patchValue(false);
        this.formGroup.get('dateStart').patchValue(moment(slotStart).format('yyyy-MM-DD'));
        this.formGroup.get('dateEnd').patchValue(moment(slotEnd).format('yyyy-MM-DD'));
      }

      this.formChangeSubscribe = this.formGroup.valueChanges.subscribe(() => {
        this.formHasChanged = true;
      });

      this.patientHourformChangeSubscribe = this.formGroup.get('patientReminderDays').valueChanges.subscribe((v) => {
        if (v && String(v).includes('-')) {
          this.formGroup.get('patientReminderDays').patchValue(0);
        }
      });

      this.patientMinuteformChangeSubscribe = this.formGroup.get('patientReminderMinutes').valueChanges.subscribe((v) => {
        if (v && String(v).includes('-')) {
          this.formGroup.get('patientReminderMinutes').patchValue(0);
        }
      });

      this.practitionerHourformChangeSubscribe = this.formGroup.get('practitionerReminderDays').valueChanges.subscribe((v) => {
        if (v && String(v).includes('-')) {
          this.formGroup.get('practitionerReminderDays').patchValue(0);
        }
      });

      this.practitionerMinuteformChangeSubscribe = this.formGroup.get('practitionerReminderMinutes').valueChanges.subscribe((v) => {
        if (v && String(v).includes('-')) {
          this.formGroup.get('practitionerReminderMinutes').patchValue(0);
        }
      });


      if (this.initialEvent) {
        let title = "Modifier un rendez-vous";
        if(this.activatedRoute.snapshot.queryParamMap.get('doDuplicate')){
          title = "Dupliquer le rendez-vous";
        }
        if (this.activatedRoute.snapshot.queryParamMap.get('highlight')){
          title = "Reporter le rendez-vous";
        }
        if (this.readOnly) {
          title = "Visualiser un rendez-vous";
        }
        const head: Header = {
          backPage: "agenda",
          isBack: true,
          title: title,
          backCallBack: async () => this.cancelBackButton()
        };
        this._send.announceHeader(head);
      } else {
        const head: Header = {
          backPage: "agenda",
          isBack: true,
          title: "Ajouter un rendez-vous"
        };
        this._send.announceHeader(head);
      }
    } catch (e) {
      this._showAlert();
    } finally {
      this.modalSrv.close(loading);
    }
  }

  private setRecurrenceLabel(eventReccurrence: EventRecurrence | null): string {
    if (eventReccurrence) {
      const daysOfWeek = [];
      let recurrenceLabel = '';
      let recurDays = '';

      if (eventReccurrence.uniteDeTemps === 'week') {
        for (const dow of eventReccurrence.parametresSemaine.uniteSemaineJoursDeLaSemaine) {
          switch (dow) {
            case 0:
              daysOfWeek.push('lundi')
              break;
            case 1:
              daysOfWeek.push('mardi')
              break;
            case 2:
              daysOfWeek.push('mercredi')
              break;
            case 3:
              daysOfWeek.push('jeudi')
              break;
            case 4:
              daysOfWeek.push('vendredi')
              break;
            case 5:
              daysOfWeek.push('samedi')
              break;
            case 6:
              daysOfWeek.push('dimanche')
              break;
          }
        }

        if (daysOfWeek.length === 1) {
          recurDays = daysOfWeek[0];
        } else if (daysOfWeek.length > 1) {
          const tmpStr = daysOfWeek.join(', ');
          const lastIndex = tmpStr.lastIndexOf(', ');
          recurDays = [tmpStr.slice(0, lastIndex), ' et ', tmpStr.slice(lastIndex + 2)].join('');
        }

        recurrenceLabel += `Toutes les ${eventReccurrence && eventReccurrence.delais === 0 ? ' ' : eventReccurrence.delais.toString() + ' '}`;
        recurrenceLabel += `semaines le ${recurDays} `;
      }

      if (eventReccurrence.uniteDeTemps === 'month' && eventReccurrence.parametresMois.type === 'day_position') {
        moment.locale('fr');
        recurrenceLabel += `Tous les ${eventReccurrence && eventReccurrence.delais === 0 ? ' ' : eventReccurrence.delais.toString() + ' '} mois le ${eventReccurrence.parametresMois.positionDansLeMois === 1 ? '1er' : eventReccurrence.parametresMois.positionDansLeMois + 'ème'} ${moment(this.formGroup && this.formGroup.get('dateStart') && this.formGroup.get('dateStart').value ? this.formGroup.get('dateStart').value : new Date()).format('dddd')} `;
      }

      if (eventReccurrence.uniteDeTemps === 'month' && eventReccurrence.parametresMois.type === 'day_of_month') {
        recurrenceLabel += `Tous les ${eventReccurrence && eventReccurrence.delais === 0 ? ' ' : eventReccurrence.delais.toString() + ' '} mois le ${this.formGroup && this.formGroup.get('dateStart') && this.formGroup.get('dateStart').value ? moment(this.formGroup.get('dateStart').value).format('DD') : new Date()} `;
      }

      recurrenceLabel += `${eventReccurrence && eventReccurrence.finRecurrence.type === 'date' ? ' jusqu\'au ' + moment(eventReccurrence.finRecurrence.date).format('DD/MM/YYYY') : ''}`;
      recurrenceLabel += `${eventReccurrence && eventReccurrence.finRecurrence.type === 'ocurrenceNumber' && eventReccurrence.uniteDeTemps === 'week' && eventReccurrence.finRecurrence.nombreOccurrence > 0 ? ' pendant ' + eventReccurrence.finRecurrence.nombreOccurrence.toString() + ' semaines' : ''}`;
      recurrenceLabel += `${eventReccurrence && eventReccurrence.finRecurrence.type === 'ocurrenceNumber' && eventReccurrence.uniteDeTemps === 'month' && eventReccurrence.finRecurrence.nombreOccurrence > 0 ? ' pendant ' + eventReccurrence.finRecurrence.nombreOccurrence.toString() + ' mois' : ''}`;
      recurrenceLabel += `${eventReccurrence && eventReccurrence.finRecurrence.type === 'ocurrenceNumber' && eventReccurrence.uniteDeTemps === 'year' && eventReccurrence.finRecurrence.nombreOccurrence > 0 ? ' pendant ' + eventReccurrence.finRecurrence.nombreOccurrence.toString() + ' ans' : ''}`;

      return recurrenceLabel;
    } else {
      return 'Aucune récurrence';
    }
  }

  private async getResources(): Promise<Array<EventResource>> {
    const resources = await this.agendaSrv.getResources();
    return resources;
  }

  private async getEventTypes(): Promise<Array<EventType>> {
    return await this.agendaSrv.getEventTypes();
  }

  private async getEventHourSplits(): Promise<Array<string>> {
    const result = await this.agendaSrv.getEventHourSplits();
    const rtd: Array<string> = [];
    for (const r of result) {
      rtd.push(r + ' minutes');
    }
    return rtd;
  }

  private async doSearchPatient(event: string) {
    try {
      if (event === '') {
        this.patientSearchList = [];
        this.searchingMessage = false;
        return;
      }

      const result = await this.patientSrv.patientsInlineSearch(event);

      this.patientSearchList = result.objects;

      if (this.patientSearchList.length === 0) {
        this.searchingMessage = true;
      } else {
        this.searchingMessage = false;
      }

      this.isSearching = false;
    } catch (e) {
      this._showAlert();
    }
  }

  private async __selectPatient(patientId: string) {
    try {
      // TEST GETADRESSES OK
      //const test = await this.patientSrv.findOnePatientAdresses(patientId);

      this.patientFormHasChanged = false;
      this.patientSearchList = [];
      this.inputSearchForm.get('searchInput').patchValue('');

      const patientTmp = await this.patientSrv.findOnePatientFiche(patientId);

      if (!this.initialEvent) {
        this.initialEvent = {
          createdAt: new Date(),
          createdBy: { nom: '', id: '' },
          id: ''
        };
      }

      this.initialEvent.patient = {
        id: patientTmp.id,
        dateNaissance: patientTmp.dateNaissance,
        nom: patientTmp.nom,
        prenom: this._strUtilsSrv.uppercaseFirstCharString(patientTmp.prenom)
      };

      if (patientTmp) {
        const tmpEvents = await this.agendaSrv.searchEvents(1, this.initialEvent.patient.id);

        this.patientFormGroup = this.formBuilder.group({
          nom: [patientTmp.nom],
          prenom: [this._strUtilsSrv.uppercaseFirstCharString(patientTmp.prenom)],
          dateNaissance: [moment(patientTmp.dateNaissance).format('DD-MM-YYYY')],
          patientAddress: [''],
          patientZip: [''],
          patientCity: [''],
          patientPhone: [''],
          patientMail: [''],
          patientAddressId: ['']
        });

        await this.setPatientEvents(tmpEvents);
        this.createPatientFormGroup = undefined;
      }

      if (patientTmp && patientTmp.adresses && patientTmp.adresses.length > 0) {
        const mainAddress = patientTmp.adresses.find(a => a.isPrincipale);
        if (mainAddress) {
          this.patientFormGroup.patchValue({
            patientAddress: mainAddress.adresse ? mainAddress.adresse : '',
            patientZip: mainAddress.codePostal ? mainAddress.codePostal : '',
            patientCity: mainAddress.ville ? mainAddress.ville : '',
            patientPhone: mainAddress.telephone ? mainAddress.telephone : '',
            patientMail: mainAddress.email ? mainAddress.email : '',
            patientAddressId: mainAddress.id
          });
        } else {
          this.patientFormGroup.patchValue({
            patientAddress: [patientTmp.adresses && patientTmp.adresses[0] && patientTmp.adresses[0].adresse ? patientTmp.adresses[0].adresse : ''],
            patientZip: [patientTmp.adresses && patientTmp.adresses[0] && patientTmp.adresses[0].codePostal ? patientTmp.adresses[0].codePostal : ''],
            patientCity: [patientTmp.adresses && patientTmp.adresses[0] && patientTmp.adresses[0].ville ? patientTmp.adresses[0].ville : ''],
            patientPhone: [patientTmp.adresses && patientTmp.adresses[0] && patientTmp.adresses[0].telephone ? patientTmp.adresses[0].telephone : ''],
            patientMail: [patientTmp.adresses && patientTmp.adresses[0] && patientTmp.adresses[0].email ? patientTmp.adresses[0].email : ''],
            patientAddressId: [patientTmp.adresses && patientTmp.adresses[0] ? patientTmp.adresses[0].id : '']
          });
        }
      }
      this.handlePatientFormChange();
    } catch (e) {
      this._showAlert();
    }
  }

  private __redirectToDossierPatient(patientId: string) {
    this.router.navigateByUrl(`/user/patient/${patientId}`);
  }

  private async __deleteEvent(eventId: string, reccurDelete?: 'coming' | 'previous_coming' | null): Promise<void> {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      await this.agendaSrv.deleteEvent(eventId, reccurDelete);
    } catch (e) {
      throw e;
    } finally {
      this.modalSrv.close(loading);
    }
  }

  public selectPatient(event: any): void {
    if (this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.id !== event.id) {
      const modal = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Attention', 'Si vous sélectionnez ce patient, il remplacera le patient actuellement lié à ce rendez-vous. Voulez-vous sélectionner ce patient ?');
      const sub = modal.instance.closeEmitter.subscribe((doReplace: boolean) => {
        if (doReplace) {
          this.__selectPatient(event);
        }

        sub.unsubscribe();
      });
    } else if (!this.initialEvent || !this.initialEvent.patient) {
      this.__selectPatient(event);
    } else if (this.initialEvent && this.initialEvent.patient && this.initialEvent.patient.id === event.id) {
      this.patientSearchList = [];
      this.inputSearchForm.get('searchInput').patchValue('');
    }
  }

  public doContactPatient(): void {

  }

  public selectContactInfos(): void {
    this.displayContactInfos = true;
  }

  public selectConsultationsInfos(): void {
    this.displayContactInfos = false;
  }

  public redirectToDossierPatient(patientId: string) {

    try {
      if (this.formHasChanged) {
        const propositions = [
          { label: 'Ne pas sauvegarder le rendez-vous', value: 'dont_save_event' },
          { label: 'Sauvegarder le rendez-vous', value: 'save_event' }
        ];

        const modal = this.modalSrv.openModalMultipleChoice(
          this.viewContainerRef,
          'Attention',
          'Vous vous apprêtez à changer de page, ce rendez-vous n\'est pas sauvegardé.',
          'Que voulez-vous faire ?',
          propositions
        );
        const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
          if (choice === 'save_event') {
            await this.saveEvent();
            this.__redirectToDossierPatient(patientId);
          } else if (choice === 'dont_save_event') {
            this.__redirectToDossierPatient(patientId);
          }

          modalSub.unsubscribe();
        });
      } else {
        this.__redirectToDossierPatient(patientId);
      }
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de l\'enregistrement des données');
    }
  }

  public createPatient() {
    this.patientFormHasChanged = false;

    if (this.profilResources.length === 0) {
      for (const r of this.resources) {
        if (r.superType === SuperTypeEnum.Profil) {
          this.profilResources.push(r.nom);
        }
      }
    }

    let responsable: string;

    const curentProfil = JSON.parse(localStorage.getItem('currentProfil') as string);
    for (const r of this.resources) {
      if (curentProfil.id === r.id) {
        responsable = r.nom;
      }
    }

    this.createPatientFormGroup = this.formBuilder.group({
      nom: ['', [Validators.required, Validators.pattern(REGEX_NAME)]],
      prenom: ['', [Validators.required, Validators.pattern(REGEX_NAME)]],
      dateDeNaissance: ['', Validators.required],
      responsable: [responsable, Validators.required]
    });

    if (this.initialEvent && this.initialEvent.patient) {
      this.initialEvent.patient = undefined;
    }

    this.patientSearchList = [];
    this.inputSearchForm.get('searchInput').patchValue('');
  }

  public async doCreatePatient(): Promise<void> {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      const responsableId = this.resources.find(r => r.nom === this.createPatientFormGroup.get('responsable').value).id;
      const createPatient: CreationPatient = {
        nom: this._strUtilsSrv.uppercaseFirstCharString(this.createPatientFormGroup.get('nom').value),
        prenom: this._strUtilsSrv.uppercaseFirstCharString(this.createPatientFormGroup.get('prenom').value),
        dateNaissance: moment(this.createPatientFormGroup.get('dateDeNaissance').value).format('YYYY-MM-DD'),
        idResponsableDossier: responsableId,
        consentement: true,
        prenomUsage: this._strUtilsSrv.uppercaseFirstCharString(this.createPatientFormGroup.get('prenom').value),
        nomUsage: this.createPatientFormGroup.get('nom').value,
        prenomsNaissance: this._strUtilsSrv.uppercaseFirstCharString(this.createPatientFormGroup.get('prenomsNaissance').value),
      };
      const idPatient = await this.patientSrv.createPatient(createPatient);

      const patient = await this.patientSrv.findOnePatientInfos(idPatient);

      if (this.initialEvent) {
        this.initialEvent.patient = {
          id: patient.id,
          dateNaissance: patient.dateNaissance,
          nom: patient.nom,
          prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)
        };
      } else {
        this.initialEvent = {
          createdAt: new Date(),
          createdBy: { id: '', nom: '' },
          id: '',
          patient: {
            id: idPatient,
            nom: patient.nom,
            prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom),
            dateNaissance: patient.dateNaissance,
          }
        }
      }

      this.patientFormGroup = this.formBuilder.group({
        nom: [patient.nom],
        prenom: [this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)],
        dateNaissance: [moment(patient.dateNaissance, "YYYY-MM-DD").format("DD-MM-YYYY")],
        patientAddress: [''],
        patientZip: [''],
        patientCity: [''],
        patientPhone: [''],
        patientMail: [''],
        patientAddressId: ['']
      });
      this.handlePatientFormChange();

      this.createPatientFormGroup = undefined;
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de l\'enregistrement du patient');
    } finally {
      this.modalSrv.close(loading);
    }
  }

  public async doUpdateAdressePatient(): Promise<void> {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      const adresses: Adresse[] = [{
        adresse: this.patientFormGroup.get('patientAddress')?.value,
        codePostal: this.patientFormGroup.get('patientZip')?.value,
        ville: this.patientFormGroup.get('patientCity')?.value,
        telephone: this.patientFormGroup.get('patientPhone')?.value,
        email: this.patientFormGroup.get('patientMail')?.value,
        isPrincipale: true,
        id: this.patientFormGroup.get('patientAddressId')?.value,
        idPatient: this.initialEvent.patient.id,
      }];

      await this.patientSrv.updateOnePatientAdresses(this.initialEvent.patient.id, adresses);

      this.createPatientFormGroup = undefined;
      this.patientFormHasChanged = false;
      this.editPatient = false;
    } catch (e) {
      this._snackbarSrv.openSnackBarError('Une erreur est survenue lors de l\'enregistrement de l\'adresse');
    } finally {
      this.modalSrv.close(loading);
    }
  }

  public cancelModifPatient(): void {
    const modal = this.modalSrv.openModalConfirmation(
      this.viewContainerRef,
      'Confirmation',
      'Si vous annulez cette édition, les informations ne seront pas sauvegardées.\n\nVoulez-vous annuler l\'édition ?'
    );
    const sub = modal.instance.closeEmitter.subscribe((res: boolean) => {
      if (res) {
        this.patientFormGroup.get('patientAddress').patchValue(this.initialPatientInfos.adress);
        this.patientFormGroup.get('patientCity').patchValue(this.initialPatientInfos.city);
        this.patientFormGroup.get('patientMail').patchValue(this.initialPatientInfos.mail);
        this.patientFormGroup.get('patientPhone').patchValue(this.initialPatientInfos.phone);
        this.patientFormGroup.get('patientZip').patchValue(this.initialPatientInfos.zip);

        this.editPatient = false;
      }
      sub.unsubscribe();
    });
  }

  public doEditPatient(): void {
    this.initialPatientInfos = {
      adress: this.patientFormGroup.get('patientAddress').value,
      city: this.patientFormGroup.get('patientCity').value,
      mail: this.patientFormGroup.get('patientMail').value,
      phone: this.patientFormGroup.get('patientPhone').value,
      zip: this.patientFormGroup.get('patientZip').value
    };

    this.editPatient = true;
  }

  public openEditRecurrence() {
    if (this.formGroup.get('dateStart').value) {
      const modal = this.modalSrv.openModal(this.viewContainerRef, EventRecurrenceComponent);
      modal.instance.recurrence = this.eventRecurrence ? this.eventRecurrence : {
        delais: 1,
        uniteDeTemps: 'week',
        dateDebutInitiale: new Date(),
        dateFinInitiale: new Date(),
        id: '',
        finRecurrence: { type: 'ocurrenceNumber', ocurrenceNumber: 2 },
        parametresSemaine: { uniteSemaineJoursDeLaSemaine: [] },
      } as EventRecurrence;
      modal.instance.eventDate = this.formGroup.get('dateStart') && this.formGroup.get('dateStart').value !== '' ? moment(this.formGroup.get('dateStart').value, 'yyyy-MM-DD').toDate() : new Date();
      const sub = modal.instance.closeEmitter.subscribe((rtd: EventRecurrence | null) => {
        if (rtd) {
          this.formGroup.get('recurrence').patchValue(this.setRecurrenceLabel(rtd));
          this.eventRecurrence = rtd;
        }
        modal.destroy();
        sub.unsubscribe();
      });
    } else {
      this.modalSrv.openAlert(this.viewContainerRef, 'Date manquante', 'Pour créer une récurrence vous devez d\'abord sélectionner une date pour votre rendez-vous');
    }
  }

  public removeRecurrence(): void {
    this.eventRecurrence = null;
    this.formGroup.get('recurrence').patchValue(this.setRecurrenceLabel(null));
  }

  private async confirmEndlessRecursive(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (this.eventRecurrence?.finRecurrence?.type === 'never') {
        const confirmEndlessRecursive = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Attention', 'Vous êtes sur le point de créer un gros volume de rendez-vous en une seul fois, cela risque de prendre du temps. Voulez-vous continuer ?');
        confirmEndlessRecursive.instance.closeEmitter.subscribe((response) => {
          resolve(response);
        });
      } else {
        resolve(true);
      }
    });
  }

  private async haveToUpdatePatient(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const confirm = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Enregistrer patient', 'Vous avez modifié des informations de ce patient sans les enregistrer. Voulez-vous enregistrer ces informations ?');
      confirm.instance.closeEmitter.subscribe((res) => {
        resolve(res);
      });
    });
  }

  private async haveToCreatePatient(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const confirm = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Enregistrer patient', 'Vous avez commencé la création d\'un patient mais il n\'est pas sauvegardé. Voulez-vous créer ce patient ?');
      confirm.instance.closeEmitter.subscribe((res) => {
        resolve(res);
      });
    });
  }

  public async saveEvent(doForce = false) {
    const doRemind = this.formGroup.get('reminder').value;
    const patientDays = this.formGroup.get('patientReminderDays').value;
    const patientHours = this.formGroup.get('patientReminderMinutes').value;
    const practitionerDays = this.formGroup.get('practitionerReminderDays').value;
    const practitionerHours = this.formGroup.get('practitionerReminderMinutes').value;
    if (doRemind && (patientDays < 0 || patientHours < 0 || practitionerDays < 0 || practitionerHours < 0)) {
      this.modalSrv.openAlert(this.viewContainerRef, 'Mauvaises valeurs', 'Vous ne pouvez pas utiliser de valeurs négatives pour les rappels de rendez-vous.');
      return;
    }

    const loading = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      if (this.patientFormHasChanged) {
        if (await this.haveToUpdatePatient()) {
          await this.doUpdateAdressePatient();
        }
      }

      if (this.createPatientFormGroup) {
        if (await this.haveToCreatePatient()) {
          if (this.createPatientFormGroup.valid) {
            await this.doCreatePatient();
          } else {
            this.modalSrv.openAlert(this.viewContainerRef, 'Création patient', 'Les champs pour la création du patient ne sont pas correctement remplis.');
            this.modalSrv.close(loading);
            return;
          }
        }
      }

      if (!this.formGroup.get('resource').value || this.formGroup.get('resource').value.length === 0) {
        this.modalSrv.openAlert(
          this.viewContainerRef,
          'Rendez-vous incomplet',
          'Au moins une ressource est nécessaire pour enregistrer un rendez-vous');
        this.modalSrv.close(loading);
        return;
      }
      if (!this.formGroup.get('type').value || this.formGroup.get('type').value.length === 0) {
        this.modalSrv.openAlert(
          this.viewContainerRef,
          'Rendez-vous incomplet',
          'Vous devez définir un type de rdv.');
        this.modalSrv.close(loading);
        return;
      }
    } catch (e) {
      throw e;
    } try {
      // Controle de surface sur la date
      this.formGroup.get('dateEnd').patchValue(this.formGroup.get('dateStart').value);
      if (moment(this.formGroup.get('dateStart').value).isAfter(moment(this.formGroup.get('dateEnd').value))) {
        this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'La date de commencement doit être inférieure à la date de fin');
        return;
      }

      // Controle de surface sur l'heure
      if (moment(this.formGroup.get('hourStart').value, 'HH:mm').isAfter(moment(this.formGroup.get('hourEnd').value, 'HH:mm'))) {
        this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'L\'heure de début doit être inférieure à l\'heure de fin');
        return;
      }
      if (moment(this.formGroup.get('hourStart').value, 'HH:mm').isSame(moment(this.formGroup.get('hourEnd').value, 'HH:mm'))) {
        this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'Les heures de début et de fin ne peuvent pas être les mêmes.');
        return;
      }

      let dateStart: Date | undefined = undefined;
      let dateEnd: Date | undefined = undefined;

      if (this.formGroup.get('dateStart').value && this.formGroup.get('dateStart').value !== ''
        && this.formGroup.get('hourStart').value && this.formGroup.get('hourStart').value !== '') {
        dateStart = moment(moment(this.formGroup.get('dateStart').value).format('YYYY-MM-DD') + ' ' + this.formGroup.get('hourStart').value).toDate();
        dateEnd = moment(dateStart).hour(Number(this.formGroup.get('hourEnd').value.split(':')[0])).minute(Number(this.formGroup.get('hourEnd').value.split(':')[1])).toDate();
      }

      if (dateStart && dateEnd) {
        const hourStart = moment().hour(Number(this.dayStartHour.split(':')[0])).minute(Number(this.dayStartHour.split(':')[1]));
        const hourEnd = moment().hour(Number(this.dayEndHour.split(':')[0])).minute(Number(this.dayEndHour.split(':')[1]));
        const eventHourStart = moment().hour(moment(dateStart).hour()).minute(moment(dateStart).minute());
        const eventHourEnd = moment().hour(moment(dateEnd).hour()).minute(moment(dateEnd).minute());
        if (eventHourStart.isBefore(hourStart, 'minute')) {
          this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'L\'heure de commencement doit être supérieur à l\'heure de début de journée');
          return;
        }

        if (eventHourEnd.isAfter(hourEnd, 'minute')) {
          this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'L\'heure de fin doit être inférieur à l\'heure de fin de journée');
          return;
        }
      }

      const typeId = this._getTypeId(this.formGroup.get('type').value);
      const resourcesIds = this._getResourcesIds(this.formGroup.get('resource').value);

      const hourSplit = Number((this.formGroup.get('hourSplit').value as string).split(' ')[0]);
      const splittedSlots = this.getHourSplitHours(dateStart, dateEnd, hourSplit);


      const resolve = await this.confirmEndlessRecursive();
      if (!resolve) {
        this.modalSrv.close(loading);
        return;
      }

      // Enregistrement des modifications
      if (!splittedSlots && hourSplit !== 0) {
        return;
      }
      if (splittedSlots) {
        if (this.initialEvent && this.initialEvent.id && this.initialEvent.id !== '') {
          const resourcesTmp: Array<EventResource> = [];
          for (const r of resourcesIds) {
            resourcesTmp.push({
              id: r.id,
              superType: r.type as SuperTypeEnum,
              nom: '',
              responsableId: '',
              type: ''
            });
          }

          let patient = this.initialEvent && this.initialEvent.patient ? this.initialEvent.patient : undefined;

          for (let i = 0; i < splittedSlots.length; i++) {
            if (this.eventRecurrence) {
              this.eventRecurrence.dateDebutInitiale = splittedSlots[i].dateStart;
              this.eventRecurrence.dateFinInitiale = splittedSlots[i].dateEnd;
            }

            if (i === 0) {
              await this._doUpdateEvent({
                id: this.initialEvent.id,
                createdAt: this.initialEvent.createdAt,
                createdBy: this.initialEvent.createdBy,
                dateDebut: splittedSlots[i].dateStart,
                dateDebutPrecedent: this.initialEvent.dateDebutPrecedent,
                dateFin: splittedSlots[i].dateEnd,
                dateFinPrecedent: this.initialEvent.dateFinPrecedent,
                deletedAt: this.initialEvent.deletedAt,
                description: this.formGroup.get('description').value,
                infosAccessible: this.initialEvent.infosAccessible,
                isDeleted: this.initialEvent.isDeleted,
                patient,
                planifie: !this.formGroup.get('toPlan').value,
                rappel: this.formGroup.get('reminder').value ? {
                  rappeler: this.formGroup.get('reminder').value,
                  rappelPatientJours: this.formGroup.get('patientReminderDays').value,
                  rappelPatientMinutes: this.formGroup.get('patientReminderMinutes').value,
                  rappelPraticienJours: this.formGroup.get('practitionerReminderDays').value,
                  rappelPraticienMinutes: this.formGroup.get('practitionerReminderMinutes').value,
                  rappelSMS: this.formGroup.get('reminderSMS').value,
                  // TODO tant que le client n'a pas de service d'envoi de SMS, le l'envoi de mail est l'option par défaut
                  // rappelMail: this.formGroup.get('reminderMail').value,
                  rappelMail: this.formGroup.get('reminder').value,
                  confirmationMeeting: this.formGroup.get('reminderConfirmation').value
                } : undefined,
                recurrence: this.eventRecurrence ? this.eventRecurrence : undefined,
                ressourses: resourcesTmp,
                status: this.initialEvent.status,
                type: this._getEventTypeFromLabel(this.formGroup.get('type').value),
                updatedAt: this.initialEvent.updatedAt
              });
              patient = undefined;
            } else {
              await this.doCreateEvent({
                dateDebut: splittedSlots[i].dateStart,
                dateFin: splittedSlots[i].dateEnd,
                description: this.formGroup.get('description').value,
                planifie: !this.formGroup.get('toPlan').value,
                rappel: this.formGroup.get('reminder').value ? {
                  rappeler: this.formGroup.get('reminder').value,
                  rappelPatientJours: this.formGroup.get('patientReminderDays').value,
                  rappelPatientMinutes: this.formGroup.get('patientReminderMinutes').value,
                  rappelPraticienJours: this.formGroup.get('practitionerReminderDays').value,
                  rappelPraticienMinutes: this.formGroup.get('practitionerReminderMinutes').value,
                  rappelSMS: this.formGroup.get('reminderSMS').value,
                  // TODO tant que le client n'a pas de service d'envoi de SMS, le l'envoi de mail est l'option par défaut
                  // rappelMail: this.formGroup.get('reminderMail').value,
                  rappelMail: this.formGroup.get('reminder').value,
                  confirmationMeeting: this.formGroup.get('reminderConfirmation').value
                } : undefined,
                ressoursesId: resourcesIds,
                typeId,
                recurrence: this.eventRecurrence
              });
            }

            if (i === splittedSlots.length - 1) {
              this._goToAgenda();
            }
          }
        } else {
          let patientId = this.initialEvent && this.initialEvent.patient ? this.initialEvent.patient.id : undefined;
          for (const s of splittedSlots) {
            const eventToCreate: CreationRendezVous = {
              dateDebut: s.dateStart,
              dateFin: s.dateEnd,
              description: this.formGroup.get('description').value,
              patientId,
              planifie: !this.formGroup.get('toPlan').value,
              rappel: this.formGroup.get('reminder').value ? {
                rappeler: this.formGroup.get('reminder').value,
                rappelPatientJours: this.formGroup.get('patientReminderDays').value,
                rappelPatientMinutes: this.formGroup.get('patientReminderMinutes').value,
                rappelPraticienJours: this.formGroup.get('practitionerReminderDays').value,
                rappelPraticienMinutes: this.formGroup.get('practitionerReminderMinutes').value,
                rappelSMS: this.formGroup.get('reminderSMS').value,
                // TODO tant que le client n'a pas de service d'envoi de SMS, le l'envoi de mail est l'option par défaut
                // rappelMail: this.formGroup.get('reminderMail').value,
                rappelMail: this.formGroup.get('reminder').value,
                confirmationMeeting: this.formGroup.get('reminderConfirmation').value
              } : undefined,
              ressoursesId: resourcesIds,
              typeId,
              recurrence: this.eventRecurrence
            }
            await this.doCreateEvent(eventToCreate);
            patientId = undefined;

          }
          this._goToAgenda();
        }
      } else {
        if (this.initialEvent && this.initialEvent.id && this.initialEvent.id !== '') {

          const resourcesTmp: Array<EventResource> = [];
          for (const r of resourcesIds) {
            resourcesTmp.push({
              id: r.id,
              superType: r.type as SuperTypeEnum,
              nom: '',
              responsableId: '',
              type: ''
            });
          }

          const didUpdate = await this._doUpdateEvent({
            id: this.initialEvent.id,
            createdAt: this.initialEvent.createdAt,
            createdBy: this.initialEvent.createdBy,
            dateDebut: dateStart,
            dateDebutPrecedent: this.initialEvent.dateDebutPrecedent,
            dateFin: dateEnd,
            dateFinPrecedent: this.initialEvent.dateFinPrecedent,
            deletedAt: this.initialEvent.deletedAt,
            description: this.formGroup.get('description').value,
            infosAccessible: this.initialEvent.infosAccessible,
            isDeleted: this.initialEvent.isDeleted,
            patient: this.initialEvent && this.initialEvent.patient ? this.initialEvent.patient : undefined,
            planifie: !this.formGroup.get('toPlan').value,
            rappel: this.formGroup.get('reminder').value ? {
              rappeler: this.formGroup.get('reminder').value,
              rappelPatientJours: this.formGroup.get('patientReminderDays').value,
              rappelPatientMinutes: this.formGroup.get('patientReminderMinutes').value,
              rappelPraticienJours: this.formGroup.get('practitionerReminderDays').value,
              rappelPraticienMinutes: this.formGroup.get('practitionerReminderMinutes').value,
              rappelSMS: this.formGroup.get('reminderSMS').value,
              // TODO tant que le client n'a pas de service d'envoi de SMS, le l'envoi de mail est l'option par défaut
              // rappelMail: this.formGroup.get('reminderMail').value,
              rappelMail: this.formGroup.get('reminder').value,
              confirmationMeeting: this.formGroup.get('reminderConfirmation').value
            } : undefined,
            recurrence: this.eventRecurrence ? this.eventRecurrence : undefined,
            ressourses: resourcesTmp,
            status: this.initialEvent.status,
            type: this._getEventTypeFromLabel(this.formGroup.get('type').value),
            updatedAt: this.initialEvent.updatedAt
          });
          if (didUpdate) {
            this._goToAgenda();
          }
        } else {
          const didCreate = await this.doCreateEvent({
            dateDebut: dateStart,
            dateFin: dateEnd,
            description: this.formGroup.get('description').value,
            patientId: this.initialEvent && this.initialEvent.patient ? this.initialEvent.patient.id : undefined,
            planifie: !this.formGroup.get('toPlan').value,
            rappel: this.formGroup.get('reminder').value ? {
              rappeler: this.formGroup.get('reminder').value,
              rappelPatientJours: this.formGroup.get('patientReminderDays').value,
              rappelPatientMinutes: this.formGroup.get('patientReminderMinutes').value,
              rappelPraticienJours: this.formGroup.get('practitionerReminderDays').value,
              rappelPraticienMinutes: this.formGroup.get('practitionerReminderMinutes').value,
              rappelSMS: this.formGroup.get('reminderSMS').value,
              // TODO tant que le client n'a pas de service d'envoi de SMS, le l'envoi de mail est l'option par défaut
              // rappelMail: this.formGroup.get('reminderMail').value,
              rappelMail: this.formGroup.get('reminder').value,
              confirmationMeeting: this.formGroup.get('reminderConfirmation').value
            } : undefined,
            ressoursesId: resourcesIds,
            typeId,
            recurrence: this.eventRecurrence
          });
          if (didCreate) {
            this._goToAgenda();
          }
        }
      }
    } catch (e) {
      throw e;
    } finally {
      this.modalSrv.close(loading);
    }
  }

  private async doCreateEvent(event: CreationRendezVous, doForce = false): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        if (!doForce && this.doForce) {
          doForce = true;
        }

        await this.agendaSrv.createEvent({
          dateDebut: event.planifie ? event.dateDebut : undefined,
          dateFin: event.planifie ? event.dateFin : undefined,
          description: event.description,
          patientId: event.patientId,
          planifie: event.planifie,
          rappel: event.rappel && event.rappel.rappeler ? {
            rappeler: event.rappel.rappeler,
            rappelPatientJours: event.rappel.rappelPatientJours,
            rappelPatientMinutes: event.rappel.rappelPatientMinutes,
            rappelPraticienJours: event.rappel.rappelPraticienJours,
            rappelPraticienMinutes: event.rappel.rappelPraticienMinutes,
            rappelSMS: this.formGroup.get('reminderSMS').value,
            // TODO tant que le client n'a pas de service d'envoi de SMS, le l'envoi de mail est l'option par défaut
            // rappelMail: this.formGroup.get('reminderMail').value,
            rappelMail: this.formGroup.get('reminder').value,
            confirmationMeeting: this.formGroup.get('reminderConfirmation').value
          } : undefined,
          ressoursesId: event.ressoursesId,
          typeId: event.typeId,
          recurrence: this.eventRecurrence
        }, doForce);
        resolve(true);
      } catch (e) {
        if (e.status && e.status === 409 && e.error && e.error.conflits
          && (e.error.conflits[0].reason === 'SLOT_CONFLICT' || e.error.conflits[0].reason === 'PERIODE_CONFLICT')) {
          const modal = this.modalSrv.openModal(this.viewContainerRef, EventConflictComponent);
          modal.instance.explication = 'L\'enregistrement de ce rendez-vous rentre en conflit avec un ou plusieurs rendez-vous et/ou périodes existants dont voici la liste';
          for (const data of e.error.conflits) {
            modal.instance.conflictsList.push(data.payload);
          }
          const sub = modal.instance.closeEmitter.subscribe(async (rtd) => {
            if (rtd) {
              resolve(await this.doCreateEvent(event, true));
            } else {
              resolve(false);
            }
            modal.destroy();
            sub.unsubscribe();
          });
        } else if (e.status && e.status === 500 && e.error === 'Event hours is overflowing opening hours of one or more resources') {
          this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'Les heures de rendez-vous rentrent en conflit avec les heures d\'ouverture d\'une ou plusieurs ressources.');
          reject(e);
        } else {
          reject(e);
        }
      }
    });
  }

  private getHourSplitHours(dateStart: Date, dateEnd: Date, splitNumber: number) {
    if (splitNumber <= 0) {
      return undefined;
    }

    const slotNumber = Math.abs(moment(dateEnd).diff(moment(dateStart), 'minute')) / splitNumber;

    if (slotNumber >= 2 && slotNumber % 1 === 0) {
      const slots: Array<{ dateStart: Date, dateEnd: Date }> = [];
      const dateStartMoment = moment(dateStart);
      for (let i = 0; i < slotNumber; i++) {
        slots.push({
          dateStart: dateStartMoment.toDate(),
          dateEnd: dateStartMoment.add(splitNumber, 'minute').toDate()
        });
      }
      return slots;
    } else {
      this._showAlert(`Impossible de créer des rendez-vous de ${splitNumber} minutes dans ce créneau de ${moment(dateStart).format('HH:mm')} à ${moment(dateEnd).format('HH:mm')}`);
      return undefined;
    }
  }

  private async _doUpdateEvent(event: Event, doForce = false): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        if (!doForce && this.doForce) {
          doForce = true;
        }

        if (this.initialEvent.recurrence && event.recurrence) {
          const confirm = this.modalSrv.openModalMultipleChoice(
            this.viewContainerRef,
            'Attention',
            'Ce rendez-vous est récurrent.',
            'Voulez-vous :',
            [
              { label: 'Ne pas le modifier', value: 'dont_update' },
              { label: 'Modifier seulement ce rendez-vous', value: 'event_only' },
              { label: 'Modifier ce rendez-vous et les suivants', value: 'coming_events' },
              { label: 'Modifier ce rendez-vous et toutes les récurrences', value: 'all_reccur' }
            ]
          );

          const updateSub = confirm.instance.closeEmitter.subscribe(async (value: string | null) => {
            if (value) {
              switch (value) {
                case 'event_only':
                  this.agendaSrv.updateEvent(event);
                  break;
                case 'coming_events':
                  this.agendaSrv.updateEvent(event, doForce, 'nextOnly');
                  break;
                case 'all_reccur':
                  this.agendaSrv.updateEvent(event, doForce, 'all');
                  break;
                default:
                  break;
              }
            }

            updateSub.unsubscribe();
            resolve(true);
          });
        } else {
          await this.agendaSrv.updateEvent(event, doForce);
          resolve(true);
        }
      } catch (e) {
        if (e.status && e.status === 409 && e.error && e.error.conflits
          && (e.error.conflits[0].reason === 'SLOT_CONFLICT' || e.error.conflits[0].reason === 'PERIODE_CONFLICT')) {
          const modal = this.modalSrv.openModal(this.viewContainerRef, EventConflictComponent);
          modal.instance.explication = 'L\'enregistrement de ce rendez-vous rentre en conflit avec un ou plusieurs rendez-vous et/ou périodes existants dont voici la liste';
          for (const data of e.error.conflits) {
            modal.instance.conflictsList.push(data.payload);
          }
          const sub = modal.instance.closeEmitter.subscribe(async (rtd) => {
            if (rtd) {
              resolve(await this._doUpdateEvent(event, true));
            } else {
              resolve(false);
            }
            modal.destroy();
            sub.unsubscribe();
          });
        } else if (e.status && e.status === 500 && e.error === 'Event hours is overflowing opening hours of one or more resources') {
          this.modalSrv.openAlert(this.viewContainerRef, 'Erreur de saisie', 'Les heures de rendez-vous rentrent en conflit avec les heures d\'ouverture d\'une ou plusieurs ressources.');
          reject(e);
        } else {
          reject(e);
        }
      }
    });
  }

  private async cancelBackButton(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      try {
        if (this.formHasChanged) {
          const propositions = [
            { label: 'Ne pas sauvegarder le rendez-vous', value: 'dont_save_event' },
            { label: 'Sauvegarder le rendez-vous', value: 'save_event' }
          ];

          const modal = this.modalSrv.openModalMultipleChoice(
            this.viewContainerRef,
            'Attention',
            'Vous vous apprétez à changer de page, ce rendez-vous n\'est pas sauvegardé.',
            'Que voulez-vous faire ?',
            propositions
          );
          const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
            if (choice === 'save_event') {
              await this.saveEvent();
              resolve(true);
            } else if (choice === 'dont_save_event') {
              resolve(true);
            }

            modalSub.unsubscribe();
          });
        } else {
          resolve(true);
        }
      } catch (e) {
        this._showAlert('Une erreur est survenue lors de l\'enregistrement de ce rendez-vous');
        resolve(false);
      }
    });
  }

  public cancel() {
    try {
      if (this.formHasChanged) {
        const propositions = [
          { label: 'Ne pas sauvegarder le rendez-vous', value: 'dont_save_event' },
          { label: 'Sauvegarder le rendez-vous', value: 'save_event' }
        ];

        const modal = this.modalSrv.openModalMultipleChoice(
          this.viewContainerRef,
          'Attention',
          'Vous vous apprétez à changer de page, ce rendez-vous n\'est pas sauvegardé.',
          'Que voulez-vous faire ?',
          propositions
        );
        const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
          if (choice === 'save_event') {
            await this.saveEvent();
          } else if (choice === 'dont_save_event') {
            this._goToAgenda();
          }

          modalSub.unsubscribe();
        });
      } else {
        this._goToAgenda();
      }
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de l\'enregistrement de ce rendez-vous');
    }
  }

  public async deleteEvent() {
    const loading = this.modalSrv.openLoading(this.viewContainerRef);

    try {
      if (this.initialEvent && this.initialEvent.id && this.initialEvent.id !== '') {
        const isRecurrent = this.initialEvent.recurrence;

        if (isRecurrent) {
          const confirm = this.modalSrv.openModalMultipleChoice(
            this.viewContainerRef,
            'Attention',
            'Ce rendez-vous est récurrent.',
            'Voulez-vous :',
            [
              { label: 'Ne pas supprimer', value: 'dont_delete' },
              { label: 'Supprimer seulement ce rendez-vous', value: 'event_only' },
              { label: 'Supprimer ce rendez-vous et les suivants', value: 'coming_events' },
              { label: 'Supprimer ce rendez-vous et toutes les récurrences', value: 'all_reccur' }
            ]
          );

          const deleteSub = confirm.instance.closeEmitter.subscribe(async (value: string | null) => {
            if (value) {
              switch (value) {
                case 'event_only':
                  await this.__deleteEvent(this.initialEvent.id);
                  deleteSub.unsubscribe();
                  this._goToAgenda();
                  break;
                case 'coming_events':
                  await this.__deleteEvent(this.initialEvent.id, 'coming');
                  deleteSub.unsubscribe();
                  this._goToAgenda();
                  break;
                case 'all_reccur':
                  await this.__deleteEvent(this.initialEvent.id, 'previous_coming');
                  deleteSub.unsubscribe();
                  this._goToAgenda();
                  break;
                default:
                  deleteSub.unsubscribe();
                  break;
              }
            }
          });
        } else {
          const modal = this.modalSrv.openModalConfirmation(this.viewContainerRef, 'Confirmation', 'Voulez-vous supprimer ce rendez-vous ?');
          const sub = modal.instance.closeEmitter.subscribe(async (doDelete: boolean) => {
            if (doDelete) {
              await this.__deleteEvent(this.initialEvent.id);
              this._goToAgenda();
            }
            sub.unsubscribe();
          });
        }
      }
    } catch (e) {
      this._showAlert();
    } finally {
      this.modalSrv.close(loading);
    }
  }

  private _getEventDureeHourMinute(): { hour: number, minute: number } {
    const eventStr = this.formGroup.get('type').value;
    const eventType = this.eventTypes.find(t => t.label === eventStr);
    const eventTypeSplt = eventType.duree.split(':');
    const eventTypeMmnt = moment().set('hour', Number(eventTypeSplt[0])).set('minute', Number(eventTypeSplt[1]));
    return {
      hour: Number(eventTypeMmnt.format('HH')),
      minute: Number(eventTypeMmnt.format('mm')),
    };
  }

  private _getStartInputMoment(): moment.Moment {
    const startTimepickerSplt = this.timepickerHourStart.timepickerTime.split(':');
    return moment().set('hour', Number(startTimepickerSplt[0])).set('minute', Number(startTimepickerSplt[1]));
  }

  private _setEventTime(newTime: moment.Moment, control: AbstractControl, timepicker: NgxTimepickerFieldComponent): void {
    control.patchValue(newTime.format('HH:mm'));
    timepicker.changeHour(Number(newTime.format('HH')));
    timepicker.changeMinute(Number(newTime.format('mm')));
  }

  private _calcDiffMinute(time: { hour: number, minute: number }, initialTime: number): number {
    if (initialTime) {
      return initialTime;
    } else {
      return Math.abs(moment().diff(moment().add(time.hour, 'hour').add(time.minute, 'minute'), 'minute'));
    }
  }

  private _setInitialdiff(): void {
    const startSplt = this.formGroup.get('hourStart').value.split(':');
    const endSplt = this.formGroup.get('hourEnd').value.split(':');
    const startMmnt = moment().set('hour', Number(startSplt[0])).set('minute', Number(startSplt[1]));
    const endMmnt = moment().set('hour', Number(endSplt[0])).set('minute', Number(endSplt[1]));
    this._initialDiff = Math.abs(startMmnt.diff(endMmnt, 'minute'));
  }

  public timeChanged(control: AbstractControl, timepicker: NgxTimepickerFieldComponent): void {

    if (this._nextEvtIsKeypress) {
      this._nextEvtIsKeypress = false;
      return;
    }

    if (timepicker.timepickerTime === control.value) {
      return;
    }

    const minSplt = this.dayStartHour.split(':');
    const minMmnt = moment().set('hour', Number(minSplt[0])).set('minute', Number(minSplt[1]));

    const maxSplt = this.dayEndHour.split(':');
    const maxMmnt = moment().set('hour', Number(maxSplt[0])).set('minute', Number(maxSplt[1]));

    const inputSplt = timepicker.timepickerTime.split(':');
    const inputMmnt = moment().set('hour', Number(inputSplt[0])).set('minute', Number(inputSplt[1]));


    if (timepicker === this.timepickerHourStart) {

      const duree = this._getEventDureeHourMinute();

      if (inputMmnt.isBefore(minMmnt)) {
        this._setEventTime(minMmnt, control, timepicker);
      } else if (inputMmnt.isSameOrAfter(maxMmnt)) {
        const diff = this._calcDiffMinute(duree, this._initialDiff);
        const newStart = maxMmnt.subtract(diff, 'minute');
        this._setEventTime(newStart, control, timepicker);
      } else {
        this._setEventTime(inputMmnt, control, timepicker);
      }

      // Dans tout les cas, on recalcule la fin du rendez-vous
      const startMmnt = this._getStartInputMoment();
      const diff = this._calcDiffMinute(duree, this._initialDiff);
      const newEnd = startMmnt.add(diff, 'minute');
      this._setEventTime(newEnd, this.formGroup.get('hourEnd'), this.timepickerHourEnd);

    } else if (timepicker === this.timepickerHourEnd) {
      const startMmnt = this._getStartInputMoment();
      if (inputMmnt.isBefore(startMmnt)) {
        const duree = this._getEventDureeHourMinute();
        const diff = this._calcDiffMinute(duree, this._initialDiff);
        const newEnd = startMmnt.add(diff, 'minute');
        this._setEventTime(newEnd, control, timepicker);
      } else if (inputMmnt.isAfter(maxMmnt)) {
        this._setEventTime(maxMmnt, control, timepicker);
      } else {
        this._setEventTime(inputMmnt, control, timepicker);
      }
      this._setInitialdiff();
    }
  }

  public async onChangePage(page: number): Promise<void> {
    try {
      const tmpEvents = await this.agendaSrv.searchEvents(page, this.initialEvent.patient.id);
      await this.setPatientEvents(tmpEvents);
    } catch (e) {
      this._showAlert();
    }
  }

  public toPLanChange(toPLan: boolean): void {
    if (!toPLan) {
      const eventStr = this.formGroup.get('type').value;
      const eventType = this.eventTypes.find(t => t.label === eventStr);
      const start = this.formGroup.get('hourStart').value;
      const newEnd = moment(start, 'HH:mm').add(Number(eventType.duree.split(':')[0]), 'hour').add(Number(eventType.duree.split(':')[1]), 'minute').format('HH:mm');

      setTimeout(() => {
        this.timepickerHourEnd.writeValue(newEnd);
        this.formGroup.get('hourEnd').patchValue(newEnd);
      }, 0);
    }
  }

  public typeChange(event: string) {
    const eventType = this.eventTypes.find(t => t.label === event);

    if (!this.formGroup.get('toPlan').value) {
      const start = this.formGroup.get('hourStart').value;
      const newEnd = moment(start, 'HH:mm').add(Number(eventType.duree.split(':')[0]), 'hour').add(Number(eventType.duree.split(':')[1]), 'minute').format('HH:mm');

      this.timepickerHourEnd.writeValue(newEnd);
      this.formGroup.get('hourEnd').patchValue(newEnd);
    }

    const resourcesLabel: Array<string> = [];

    const formResources = this.formGroup.get('resource').value;
    if (formResources && formResources.length > 0) {
      for (const r of formResources) {
        resourcesLabel.push(r);
      }
    }

    for (const r of eventType.ressources) {
      if (!resourcesLabel.includes(r.nom)) {
        resourcesLabel.push(r.nom);
      }
    }

    this.formGroup.get('resource').patchValue(resourcesLabel);
    this._setInitialdiff();
  }

  public doUppercaseInputValue(absCtrl: AbstractControl) {
    absCtrl.setValue(this._strUtilsSrv.removeAccents(this._strUtilsSrv.uppercaseString(absCtrl.value)));
  }

  public doUppercaseFirstLetterInputValue(absCtrl: AbstractControl) {
    absCtrl.setValue(this._strUtilsSrv.uppercaseFirstCharString(absCtrl.value));
  }

  public async getLastPatient() {
    this.isSearching = true;
    try {
      const lastPatient = await this.patientSrv.findLastPatient();
      if (lastPatient && lastPatient.id) {
        this.formHasChanged = true;
        await this.__selectPatient(lastPatient.id);
      } else {
        return;
      }

    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la récupération du dernier patient');
    } finally {
      this.isSearching = false;
    }
  }

  private _getTypeId(typeLabel: string | undefined): string | undefined {
    if (!typeLabel) {
      return undefined;
    }

    const eventType = this.eventTypes.find((t) => t.label === typeLabel);

    return eventType && eventType.id && eventType.id !== '' ? eventType.id : undefined
  }

  private _getResourcesIds(ressourcesLabel: Array<string>): Array<RessourceCreationRendezVous> | undefined {
    const rtd: Array<RessourceCreationRendezVous> = [];

    for (const r of this.resources) {
      if (ressourcesLabel.includes(r.nom)) {
        rtd.push({ id: r.id, type: r.superType })
      }
    }

    return rtd.length > 0 ? rtd : undefined;
  }

  private _goToAgenda() {
    this.router.navigateByUrl('/user/agenda');
  }

  private _getEventTypeFromLabel(typeLabel: string): EventType {
    return this.eventTypes.find(type => type.label === typeLabel);
  }

  private setPatientEvents(events: Paginated<Event>) {
    const tmp: Array<PatientConsultationTableDisplay> = [];

    for (const e of events.objects) {
      const consultation: PatientConsultationTableDisplay = {
        date: e.dateDebut,
        heure: moment(e.dateDebut).format('HH:mm'),
        status: e.status ? e.status.label : '',
        type: e.type ? e.type.label : ''
      };

      if (e.status && e.status.label === "Non honoré") {
        Object.defineProperty(consultation, 'textColor', { value: 'ff6659' });
      }

      tmp.push(consultation);
    }

    if (this.patientEvents) {
      this.patientEvents.objects = [...tmp];
      this.patientEvents.page = events.page;
      this.patientEvents.perpage = events.perpage;
      this.patientEvents.total = events.total;
    } else {
      this.patientEvents = {
        objects: [...tmp],
        page: events.page,
        perpage: events.perpage,
        total: events.total,
      }
    }
  }

  private handlePatientFormChange() {
    if (this.patientFormGroup) {
      this.patientFormChangeSubscribe = this.patientFormGroup.valueChanges.subscribe(() => {
        this.patientFormHasChanged = true;
      });
    }
  }

  private _showAlert(msg?: string): void {
    msg = msg ? msg : 'Une erreur est survenue lors de la récupération des informations de cette page';

    this.modalSrv.openAlert(this.viewContainerRef, 'Erreur', msg);
  }

}
